import { render, staticRenderFns } from "./myMetaorderNumber.vue?vue&type=template&id=56e840ea&functional=true&"
import script from "./myMetaorderNumber.vue?vue&type=script&lang=js&"
export * from "./myMetaorderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports